import { render, staticRenderFns } from "./Vendidos.vue?vue&type=template&id=766e05f4&"
import script from "./Vendidos.vue?vue&type=script&lang=js&"
export * from "./Vendidos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports